<app-header></app-header>
<div id="main_app" class="container-fluid">
  <div class="container">
    <div class="ranking_title">{{ 'Setting' | translate}}</div>
    <div class="ranking_excerpt">{{ 'SettingInfo' | translate}}</div>
    <ul class="nav nav-pills nav_options" id="pills-tab" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="item_options active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home"
                type="button" role="tab" aria-controls="pills-home"
                aria-selected="true">{{ 'SettingTimer' | translate}}</button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="item_options" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile"
                type="button" role="tab" aria-controls="pills-profile"
                aria-selected="false">{{ 'NotificationsAndSounds' | translate}}</button>
      </li>
      <li class="nav-item" role="presentation">
        <button (click)="chartStake()" class="item_options" id="pills-contact-tab" data-bs-toggle="pill"
                data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact"
                aria-selected="false">{{ 'Categories' | translate}}</button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="item_options" id="pills-extra-tab" data-bs-toggle="pill" data-bs-target="#pills-extra"
                type="button" role="tab" aria-controls="pills-extra"
                aria-selected="false">{{ 'OtherSetting' | translate}}</button>
      </li>
    </ul>
    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
        <div class="box_options">
          <div class="alert_bar" *ngIf="proVersion === 'false' || userIsLoggedIn == false">
            {{ 'TimerSettingInfo' | translate}}
<!--            <a *ngIf="proVersion === 'false'" [routerLink]="['/pricing']">{{ 'UpgradeYourAccount' | translate}}</a>-->
<!--            <a *ngIf="userIsLoggedIn == false" [routerLink]="['/login']">{{ 'UpgradeYourAccount' | translate}}</a>-->
            <a [routerLink]="['/pricing']">{{ 'UpgradeYourAccount' | translate}}</a>
          </div>
          <form action="">
            <div class="col_options">
              <div class="col_option_title">{{ 'PomodoroTimeLength' | translate}}</div>
              <div class="col_option_value">
                <button class="minus" [disabled]="controllerOne || !helperVar"
                        [ngClass]="{'not-pro-version': !helperVar}" (click)="decreaseTimeLength()"><i
                  class="icon-minus"></i></button>
                <input type="number"
                       name="pomodoroRepository.defaultMeasure"
                       [(ngModel)]="setting.pomodoro_time_length"
                       (change)="getDuration(setting.pomodoro_time_length)" [disabled]="!helperVar"
                       [ngStyle]="{'cursor': !helperVar? 'no-drop' : 'pointer' }">
                <button class="plus" [disabled]="!helperVar" [ngClass]="{'not-pro-version': !helperVar}"
                        (click)="increaseTimeLength()"><i class="icon-plus"></i></button>
              </div>
            </div><!-- .col_options -->
            <div class="col_options">
              <div class="col_option_title">{{ 'PomodoroCountInCycle' | translate}}</div>
              <div class="col_option_value">
                <button class="minus" [disabled]="controllerTwo || !helperVar"
                        [ngClass]="{'not-pro-version': !helperVar}" (click)="decreasePomoCount()"><i
                  class="icon-minus"></i></button>
                <input type="number"
                       id="pomoCount"
                       name="pomodoroRepository.defaultCount"
                       [(ngModel)]="setting.pomodoro_count_after_long_rest"
                       (change)="getPomoCount(setting.pomodoro_count_after_long_rest)" [disabled]="!helperVar">
                <button [disabled]="!helperVar" class="plus" [ngClass]="{'not-pro-version': !helperVar}"
                        (click)="increasePomoCount()"><i class="icon-plus"></i></button>
              </div>
            </div><!-- .col_options -->
            <div class="col_options">
              <div class="col_option_title">{{ 'PomodoroShortRest' | translate}}</div>
              <div class="col_option_value">
                <button class="minus" [disabled]="controllerThree || !helperVar"
                        [ngClass]="{'not-pro-version': !helperVar}" (click)="decreaseShortBreak()"><i
                  class="icon-minus"></i></button>
                <input type="number"
                       name="pomodoroRepository.shortBreak"
                       [(ngModel)]="setting.short_rest_time"
                       (change)="getShortBreak(setting.short_rest_time)" [disabled]="!helperVar"
                       [ngStyle]="{'cursor': !helperVar? 'no-drop' : 'pointer' }">
                <button [disabled]="!helperVar" class="plus" [ngClass]="{'not-pro-version': !helperVar}"
                        (click)="increaseShortBreak()"><i class="icon-plus"></i></button>
              </div>
            </div><!-- .col_options -->
            <div class="col_options">
              <div class="col_option_title">{{ 'PomodoroLongRest' | translate}}</div>
              <div class="col_option_value">
                <button class="minus" [disabled]="controllerFour || !helperVar"
                        [ngClass]="{'not-pro-version': !helperVar}" (click)="decreaseLongBreak()"><i
                  class="icon-minus"></i></button>
                <input type="number"
                       name="pomodoroRepository.longBreak"
                       [(ngModel)]="setting.long_rest_time"
                       (change)="getLongBreak(setting.long_rest_time)"
                       appOnlyNumber
                       required [disabled]="!helperVar"
                       [ngStyle]="{'cursor': !helperVar? 'no-drop' : 'pointer' }">
                <button [disabled]="!helperVar" class="plus" [ngClass]="{'not-pro-version': !helperVar}"
                        (click)="increaseLongBreak()"><i class="icon-plus"></i></button>
              </div>
            </div><!-- .col_options -->
            <div class="col_options">
              <div class="col_option_title">{{ 'AutoNextPomodoro' | translate}}</div>
              <div class="col_option_value">
                <label class="switch" for="startPomo">
                  <input type="checkbox" id="startPomo" checked name="pomodoroRepository.autoNextPomodoro"
                         [(ngModel)]="setting.start_next_pomodoro_automatic"
                         (change)="getAutoNextPomodoro(setting.start_next_pomodoro_automatic)" [disabled]="!helperVar">
                  <div class="slider round" [ngStyle]="{'cursor': !helperVar? 'no-drop' : 'pointer' }"></div>
                </label>
              </div>
            </div><!-- .col_options -->
            <div class="col_options">
              <div class="col_option_title">{{ 'AutoNextBreak' | translate}}</div>
              <div class="col_option_value">
                <label class="switch" for="startBreak">
                  <input type="checkbox" id="startBreak" checked name="pomodoroRepository.autoNextRest"
                         [(ngModel)]="setting.start_next_rest_automatic"
                         (change)="getAutoNextRest(setting.start_next_rest_automatic)" [disabled]="!helperVar">
                  <div class="slider round" [ngStyle]="{'cursor': !helperVar? 'no-drop' : 'pointer' }"></div>
                </label>
              </div>
            </div><!-- .col_options -->
            <div class="row_options d-flex" *ngIf="userIsLoggedIn">
              <button class="pos-rel w-50-per" (click)="updateSetting()" [disabled]="firstSpinner">
                {{ 'SaveTheChanges' | translate}}
                <mat-spinner style="margin: 0 5px 0 0; vertical-align: middle; display: inline-block !important;"
                             matSuffix [diameter]="20" color="accent" *ngIf="firstSpinner"></mat-spinner>
              </button>
              <div class="w-50-per pr-2">
                <button class="pos-rel reset_mode" (click)="defaultMode()" matTooltip="حالت پیشفرض تکنیک پومودورو">
                  بازگشت به حالت پیش فرض
                </button>
              </div>
            </div>
            <div class="row_options" *ngIf="!userIsLoggedIn">
              <button class="pos-rel" style="cursor: no-drop;" disabled (click)="sendSuccessMessage()">
                {{ 'SaveTheChanges' | translate}}
              </button>
            </div>
            <div class="clearfix"></div>
          </form>
        </div>
      </div>
      <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
        <div class="box_options">
          <form action="">
            <div>
              <div class="options_item_title">{{ 'Notifications' | translate}}</div>
              <div>
                <div class="col_options w-100">
                  <div class="col_option_title">
                    {{ 'BrowserPermit' | translate}}
                    <ng-container *ngIf="notificationAllow === 'granted'">
                      <strong>داده شده است.</strong>
                    </ng-container>
                    <ng-container *ngIf="notificationAllow === 'default'">
                      <strong>داده نشده.</strong>
                      <button class="active-notification" (click)="permissionNotification()">  فعال سازی </button>
                    </ng-container>
                    <ng-container *ngIf="notificationAllow === 'denied'">
                      <strong>داده نشده.</strong>
                      <div class="notification_help">
                        <mat-icon matTooltip="
                        شما اجازه ارسال اعلان (Notification) از طریق مرورگر را مسدود کرده اید، از طریق تنظیمات مرورگر آن را فعال کنید.
                        "
                                  matTooltipPosition="above">help_outline</mat-icon>
                      </div>
                    </ng-container>
                  </div>
<!--                  <div class="col_option_value">-->
<!--                    <label class="switch" for="permissionStatus">-->
<!--                      <input type="checkbox" id="permissionStatus" checked name="permissionStatus"-->
<!--                             [(ngModel)]="permissionStatus" (change)="permissionNotification()">-->
<!--                      <div class="slider round"></div>-->
<!--                    </label>-->
<!--                    &lt;!&ndash;                    <button class="btn btn-outline-dark" [(ngModel)]="permissionStatus">{{ 'Permit' | translate}}</button>&ndash;&gt;-->
<!--                  </div>-->
                </div><!-- .col_options -->
                <div class="clearfix"></div>
              </div>
              <div>
                <div class="col_options">
                  <div class="col_option_title">{{ 'SendNotificationAfterPomodoro' | translate}}</div>
                  <div class="col_option_value">
                    <label class="switch" for="sendPomodoroNotification">
                      <input type="checkbox" id="sendPomodoroNotification" checked
                             name="pomodoroRepository.sendPomodoroNotification"
                             [(ngModel)]="setting.send_pomodoro_notification"
                             (change)="getPomodoroNotification(setting.send_pomodoro_notification)">
                      <div class="slider round"></div>
                    </label>
                  </div>
                </div><!-- .col_options -->
                <div class="col_options">
                  <div class="col_option_title">{{ 'SendNotificationAfterBreak' | translate}}</div>
                  <div class="col_option_value">
                    <label class="switch" for="sendRestNotification">
                      <input type="checkbox" id="sendRestNotification" checked
                             name="pomodoroRepository.sendRestNotification"
                             [(ngModel)]="setting.send_rest_notification"
                             (change)="getRestNotification(setting.send_rest_notification)">
                      <div class="slider round"></div>
                    </label>
                  </div>
                </div><!-- .col_options -->
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="spacer-t20" *ngIf="userIsLoggedIn === true">
              <div class="options_item_title">{{ 'AlarmSound' | translate}}</div>
              <div class="col_options">
                <div class="col_option_sound_title">{{ 'AlarmAfterPomodoro' | translate}}</div>
                <div class="col_option_sound_value">
                  <div class="row_option_sound" *ngFor="let sound of pomodoroRepository.pomoSounds">
                    <div class="col_sound_item">
                      <!--                      <input type="radio" name="sound_pomodoro" (click)="pomodoroRepository.setPomodoroSound(sound)"-->
                      <!--                             [checked]="sound.isSelected == true">-->
                      <!--                      <input type="radio" name="sound_pomodoro" (click)="pomodoroRepository.setPomodoroSound(sound)"-->
                      <!--                             [checked]="{true : setting.pomodoro_sound.id === sound.id}">-->
                      <input type="radio" name="sound_pomodoro" (click)="pomodoroRepository.setPomodoroSound(sound)"
                             [value]="pomodoroRepository.pomodoroSoundId === sound.id"
                             [checked]="pomodoroRepository.pomodoroSoundId === sound.id">
                    </div>
                    <div class="col_sound_player">
                      <audio controls>
                        <source [src]="[sound.url]" type="audio/mpeg">
                      </audio>
                    </div>
                    <div class="clearfix"></div>
                  </div><!-- .row_option_sound -->
                </div><!-- .col_option_sound_value -->
              </div><!-- .col_options -->
              <div class="col_options">
                <div class="col_option_sound_title">{{ 'AlarmAfterBreak' | translate}}</div>
                <div class="col_option_sound_value">
                  <div class="row_option_sound" *ngFor="let sound of pomodoroRepository.breakSounds">
                    <div class="col_sound_item">
                      <input type="radio" name="sound_break"
                             (click)="pomodoroRepository.setBreakSound(sound)"
                             [value]="pomodoroRepository.pomodoroSoundId"
                             [checked]="pomodoroRepository.restSoundId === sound.id">
                      <!--                      <input type="radio" name="sound_break"-->
                      <!--                             (click)="pomodoroRepository.setBreakSound(sound)">-->
                    </div>
                    <div class="col_sound_player">
                      <audio controls>
                        <source [src]="[sound.url]" type="audio/mpeg">
                      </audio>
                    </div>
                    <div class="clearfix"></div>
                  </div><!-- .row_option_sound -->
                </div><!-- .col_option_sound_value -->
              </div><!-- .col_options -->
              <div class="row_options" *ngIf="userIsLoggedIn">
                <button (click)="updateSetting()" [disabled]="firstSpinner">
                  {{ 'SaveTheChanges' | translate}}
                  <mat-spinner style="margin: 0 5px 0 0; vertical-align: middle; display: inline-block !important;"
                               matSuffix [diameter]="20" color="accent" *ngIf="firstSpinner"></mat-spinner>
                </button>
              </div>
              <div class="row_options" *ngIf="!userIsLoggedIn">
                <button class="pos-rel" (click)="sendSuccessMessage()">
                  {{ 'SaveTheChanges' | translate}}
                </button>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="spacer-t20" *ngIf="userIsLoggedIn === false">
              <div class="options_item_title">{{ 'AlarmSound' | translate}}</div>
              <div class="col_options">
                <div class="col_option_sound_title">{{ 'AlarmAfterPomodoro' | translate}}</div>
                <div class="col_option_sound_value">
                  <div class="row_option_sound" *ngFor="let sound of pomodoroRepository.pomoSoundsInNoneLoginMode">
                    <div class="col_sound_item">
                      <input type="radio" name="sound_pomodoro" (click)="pomodoroRepository.setPomodoroSound(sound)"
                             [checked]="sound.isSelected == true">
                      <!--                      <input type="radio" name="sound_pomodoro" (click)="pomodoroRepository.setPomodoroSound(sound)"-->
                      <!--                             [checked]="{true : sound.id === setting.id}">-->
                    </div>
                    <div class="col_sound_player">
                      <audio controls>
                        <source [src]="[sound.soundEffect]" type="audio/mpeg">
                      </audio>
                    </div>
                    <div class="clearfix"></div>
                  </div><!-- .row_option_sound -->
                </div><!-- .col_option_sound_value -->
              </div><!-- .col_options -->
              <div class="col_options">
                <div class="col_option_sound_title">{{ 'AlarmAfterBreak' | translate}}</div>
                <div class="col_option_sound_value">
                  <div class="row_option_sound" *ngFor="let sound of pomodoroRepository.breakSoundsInNoneLoginMode">
                    <div class="col_sound_item">
                      <input type="radio" name="sound_break" (click)="pomodoroRepository.setBreakSound(sound)"
                             [checked]="sound.isSelected == true">
                    </div>
                    <div class="col_sound_player">
                      <audio controls>
                        <source [src]="[sound.soundEffect]" type="audio/mpeg">
                      </audio>
                    </div>
                    <div class="clearfix"></div>
                  </div><!-- .row_option_sound -->
                </div><!-- .col_option_sound_value -->
              </div><!-- .col_options -->
              <div class="row_options" *ngIf="userIsLoggedIn">
                <button (click)="updateSetting()" [disabled]="firstSpinner">
                  {{ 'SaveTheChanges' | translate}}
                  <mat-spinner style="margin: 0 5px 0 0; vertical-align: middle; display: inline-block !important;"
                               matSuffix [diameter]="20" color="accent" *ngIf="firstSpinner"></mat-spinner>
                </button>
              </div>
              <div class="row_options" *ngIf="!userIsLoggedIn">
                <button class="pos-rel" (click)="sendSuccessMessage()">
                  {{ 'SaveTheChanges' | translate}}
                </button>
              </div>
              <div class="clearfix"></div>
            </div>
          </form>
        </div>
      </div>
      <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
        <div class="box_options">
          <div class="options_item_title">{{ 'CategoriesManagement' | translate}}</div>
          <br>
          <div class="row justify-content-center align-items-center" *ngIf="pomodoroRepository.categories.length == 0">
            {{ 'ThereIsNoCategory' | translate }}
          </div>
          <ng-container>
            <div class="options_category_item" *ngFor="let category of pomodoroRepository.categories;index as i;">
              <div class="options_category_title" *ngIf="!editMode">{{category}}</div>
              <input class="input-edit" *ngIf="editMode" #inp type="text" [(ngModel)]="pomodoroRepository.categories[i]"
                     (keydown)="onBlur($event)">
              <div class="options_category_delete"
                   (click)="deleteFromCategories(category)">{{ 'Delete' | translate}}</div>
              <div class="options_category_edit" *ngIf="!editMode" (click)="turnEditMode()">{{ 'Edit' | translate}}</div>
              <div class="options_category_set" *ngIf="editMode" (click)="turnEditMode()">ثبت</div>
              <div class="clearfix"></div>
            </div><!-- .options_category_item -->
          </ng-container>
<!--          <ng-container *ngIf="editMode">-->
<!--            <div class="options_category_item" *ngFor="let category of pomodoroRepository.categories; index as i;">-->
<!--              <div class="options_category_title">-->
<!--                <input class="edit-cat" type="text" (keyup.enter)="syncCat()"-->
<!--                       [(ngModel)]="pomodoroRepository.categories[i]">-->
<!--              </div>-->
<!--              <div class="options_category_delete"-->
<!--                   (click)="deleteFromCategories(category)">{{ 'Delete' | translate}}</div>-->
<!--              <div class="options_category_set" (click)="turnEditMode()">ثبت</div>-->
<!--              <div class="clearfix"></div>-->
<!--            </div>&lt;!&ndash; .options_category_item &ndash;&gt;-->
<!--          </ng-container>-->
          <div class="main_chart" *ngIf="showChart">
            <div class="main_chart_title">{{ 'TimeChartInTermsOfCategories' | translate }}</div>
            <div class="main_chart_description">
              {{ 'TimeChartInTermsOfCategoriesDescription' | translate }}
            </div>
            <div class="second-chart">
              <div class="chart-btn">
                <ul>
                  <li (click)="onClick(3)" [ngClass]="{'active': tab==='tab3'}">
                    <a (click)="getWeekDoughtChart()">{{ 'Week' | translate }}</a>
                  </li>
                  <li (click)="onClick(2)" [ngClass]="{'active': tab==='tab2'}">
                    <a (click)="getMonthDoughtChart()">{{ 'Month' | translate }}</a>
                  </li>
                  <li (click)="onClick(1)" [ngClass]="{'active': tab==='tab1'}">
                    <a (click)="getYearDoughtChart()">{{ 'Year' | translate }}</a>
                  </li>
                </ul>
                <div class="clearfix"></div>
              </div>
              <div class="doughnut">
                <canvas baseChart style="display: block; width: 500px; height: 500px"
                        [data]="doughnutChartData"
                        [labels]="doughnutChartLabels"
                        [colors]="pieChartColors"
                        [chartType]="doughnutChartType">
                </canvas>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="pills-extra" role="tabpanel" aria-labelledby="pills-extra-tab">
        <div class="box_options">
          <div class="alert_bar" *ngIf="proVersion == 'false' || userIsLoggedIn == false">
            {{ 'DarkModeSettingInfo' | translate}}
<!--            <a *ngIf="proVersion === 'false'" [routerLink]="['/pricing']">{{ 'UpgradeYourAccount' | translate}}</a>-->
<!--            <a *ngIf="userIsLoggedIn == false" [routerLink]="['/login']">{{ 'UpgradeYourAccount' | translate}}</a>-->
            <a [routerLink]="['/pricing']">{{ 'UpgradeYourAccount' | translate}}</a>
          </div>
          <div class="col_options">
            <div class="col_option_title">{{ 'DarkMode' | translate }}</div>
            <div class="col_option_value">
              <label class="switch" for="theme">
                <input type="checkbox" id="theme" checked name="pomodoroRepository.darkMode"
                       [(ngModel)]="setting.dark_mode" (change)="darkModeSwitch(setting.dark_mode)"
                       [disabled]="!helperVar || userIsLoggedIn == false">
                <div class="slider round"
                     [ngStyle]="{'cursor': !helperVar || userIsLoggedIn == false? 'no-drop' : 'pointer' }"></div>
              </label>
            </div>
          </div><!-- .col_options -->
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div><!-- .container -->
</div>
<!-- #main_app -->
<app-footer></app-footer>
